var d = (n, i, r) => new Promise((l, t) => {
  var a = (e) => {
    try {
      m(r.next(e));
    } catch (s) {
      t(s);
    }
  }, p = (e) => {
    try {
      m(r.throw(e));
    } catch (s) {
      t(s);
    }
  }, m = (e) => e.done ? l(e.value) : Promise.resolve(e.value).then(a, p);
  m((r = r.apply(n, i)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import y from "./relatedApproval.ce.vue.js";
import { vCopyVueucStylesToShadowDom as _ } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { vShadowPropertyPolyfill as h } from "../../utils/vShadowPropertyPolyfill.js";
import { defineComponent as I, useTemplateRef as v, openBlock as c, createBlock as f, withCtx as u, withDirectives as w, createVNode as P } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as b } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as o } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import S from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import x from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import N from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const Z = /* @__PURE__ */ I({
  __name: "index.ce",
  setup(n, { expose: i }) {
    const r = v("relatedApprovalRefs");
    let l = null;
    const t = b(), a = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, p = (e) => d(this, null, function* () {
      var s;
      return (s = r.value) == null || s.open({
        selectMode: e.selectMode || "",
        businessId: e.businessId || "",
        isCreatorId: e.isCreatorId || !1,
        orderId: e.orderId || "",
        businessType: e.businessType,
        customerId: e.customerId || "",
        list: e.list || []
      }), new Promise((C) => {
        l = C;
      });
    }), m = (e) => {
      l && (l(e), l = null);
    };
    return i({ open: p }), (e, s) => (c(), f(o(x), {
      locale: o(R),
      "date-locale": o(S),
      "theme-overrides": a,
      "style-mount-target": o(t)
    }, {
      default: u(() => [
        w((c(), f(o(N), { to: o(t) }, {
          default: u(() => [
            P(y, {
              ref_key: "relatedApprovalRefs",
              ref: r,
              onSubmit: m
            }, null, 512)
          ]),
          _: 1
        }, 8, ["to"])), [
          [o(_), o(t)],
          [o(h), o(t)]
        ])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"]));
  }
});
export {
  Z as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/related-approval/index.ce.vue2.js
// module id = 1327
// module chunks = 67